import { PAGE_IDS } from './permissions';

/** Common API request header bundles (x-api-id / x-page-id / x-permission-id). */
export const API_HEADERS = {
  APPLICANT_SEARCH: { 'x-api-id': 1, 'x-page-id': PAGE_IDS.APPLICANT_SEARCH } as const,
  APPLICANT_SEARCH_COUNTRIES: { 'x-api-id': 16, 'x-page-id': PAGE_IDS.APPLICANT_SEARCH } as const,
  APPLICANT_SEARCH_UPDATE_VACANCY_CODE: { 'x-api-id': 36, 'x-page-id': PAGE_IDS.APPLICANT_SEARCH } as const,
  APPLICANT_SEARCH_UPDATE_COUNTRY: { 'x-api-id': 37, 'x-page-id': PAGE_IDS.APPLICANT_SEARCH } as const,

  APPLICANT_PROFILE_FULL_GET: { 'x-api-id': 18, 'x-page-id': PAGE_IDS.APPLICANT_PROFILE } as const,
  APPLICANT_PROFILE_UPDATE: { 'x-api-id': 22, 'x-page-id': PAGE_IDS.APPLICANT_PROFILE } as const,
  /** `/settings/skills` on vacancy add (also used from applicant profile skill editor). */
  SETTINGS_SKILLS_VACANCY_ADD: { 'x-api-id': 8, 'x-page-id': PAGE_IDS.VACANCY_ADD } as const,
  APPLICANT_PROFILE_LANGUAGES_LOOKUP: { 'x-api-id': 24, 'x-page-id': PAGE_IDS.APPLICANT_PROFILE } as const,

  /** `/system/qualifications` on vacancy add. */
  SETTINGS_QUALIFICATIONS_VACANCY_ADD: { 'x-api-id': 7, 'x-page-id': PAGE_IDS.VACANCY_ADD } as const,
  APPLICANT_PROFILE_INSTITUTES_LOOKUP: { 'x-api-id': 23, 'x-page-id': PAGE_IDS.APPLICANT_PROFILE } as const,
  /** Technologies for an experience row (`/rec/applicant/search/.../company/...`). */
  APPLICANT_PROFILE_EXPERIENCE_COMPANY_TECH: { 'x-api-id': 19, 'x-page-id': PAGE_IDS.APPLICANT_PROFILE } as const,

  APPLICANT_HISTORY_INTERVIEWS: { 'x-api-id': 38, 'x-page-id': PAGE_IDS.APPLICANT_HISTORY } as const,
  APPLICANT_HISTORY_TIMELINE: { 'x-api-id': 21, 'x-page-id': PAGE_IDS.APPLICANT_HISTORY } as const,
  APPLICANT_HISTORY_BASIC_GET: { 'x-api-id': 27, 'x-page-id': PAGE_IDS.APPLICANT_HISTORY } as const,
  APPLICANT_HISTORY_STATUSES_LOOKUP: { 'x-api-id': 28, 'x-page-id': PAGE_IDS.APPLICANT_HISTORY } as const,
  APPLICANT_HISTORY_UPDATE: { 'x-api-id': 25, 'x-page-id': PAGE_IDS.APPLICANT_HISTORY } as const,

  APPLICANT_ADDITIONAL_INFO_BASIC_GET: { 'x-api-id': 27, 'x-page-id': PAGE_IDS.APPLICANT_ADDITIONAL_INFO } as const,
  APPLICANT_ADDITIONAL_INFO_QUESTION_ANSWERS: { 'x-api-id': 48, 'x-page-id': PAGE_IDS.APPLICANT_ADDITIONAL_INFO } as const,
  APPLICANT_ADDITIONAL_INFO_UPDATE: { 'x-api-id': 26, 'x-page-id': PAGE_IDS.APPLICANT_ADDITIONAL_INFO } as const,
  APPLICANT_ADDITIONAL_INFO_SAVE_ANSWER: { 'x-api-id': 49, 'x-page-id': PAGE_IDS.APPLICANT_ADDITIONAL_INFO } as const,

  APPLICANT_MESSAGES_LIST: { 'x-api-id': 46, 'x-page-id': PAGE_IDS.APPLICANT_MESSAGES } as const,
  APPLICANT_JIRA_COMMENTS: { 'x-api-id': 43, 'x-page-id': PAGE_IDS.APPLICANT_JIRA_COMMENTS } as const,

  LINKEDIN_PROFILE_READ: { 'x-api-id': 3, 'x-page-id': PAGE_IDS.LINKEDIN_SEARCH } as const,

  VACANCY_SEARCH_LIST: { 'x-api-id': 4, 'x-page-id': PAGE_IDS.VACANCY_SEARCH } as const,
  VACANCY_SEARCH_DELETE: { 'x-api-id': 29, 'x-page-id': PAGE_IDS.VACANCY_SEARCH } as const,
  VACANCY_SEARCH_CLONE: { 'x-api-id': 30, 'x-page-id': PAGE_IDS.VACANCY_SEARCH } as const,
  VACANCY_SEARCH_PUBLISH_JOB: {
    'x-permission-id': 29,
    'x-api-id': 31,
    'x-page-id': PAGE_IDS.VACANCY_SEARCH,
  } as const,
  VACANCY_SEARCH_DELETE_JOB: {
    'x-permission-id': 30,
    'x-api-id': 32,
    'x-page-id': PAGE_IDS.VACANCY_SEARCH,
  } as const,
  VACANCY_SEARCH_WITHDRAW: {
    'x-permission-id': 31,
    'x-api-id': 31,
    'x-page-id': PAGE_IDS.VACANCY_SEARCH,
  } as const,

  ADD_APPLICANT_DESIGNATIONS: { 'x-api-id': 6, 'x-page-id': PAGE_IDS.APPLICANT_ADD } as const,
  ADD_APPLICANT_SUBMIT: { 'x-api-id': 2, 'x-page-id': PAGE_IDS.APPLICANT_ADD } as const,
  VACANCY_CODES_LOOKUP: { 'x-api-id': 35, 'x-page-id': PAGE_IDS.APPLICANT_SEARCH } as const,
  COUNTRIES_LOOKUP: { 'x-api-id': 6, 'x-page-id': PAGE_IDS.VACANCY_ADD } as const,
  VACANCY_FORM_DEFAULT: { 'x-api-id': 11, 'x-page-id': PAGE_IDS.VACANCY_EDIT } as const,
  VACANCY_EDIT_FORM_UPDATE_DETAILS: { 'x-api-id': 12, 'x-page-id': PAGE_IDS.VACANCY_EDIT } as const,
  VACANCY_ADD_CREATE: { 'x-api-id': 10, 'x-page-id': PAGE_IDS.VACANCY_ADD } as const,

  VACANCY_JD_SAVE_ADD: { 'x-api-id': 13, 'x-page-id': PAGE_IDS.VACANCY_JD_ADD } as const,
  VACANCY_JD_SAVE_EDIT: { 'x-api-id': 13, 'x-page-id': PAGE_IDS.VACANCY_JD_EDIT } as const,

  VACANCY_UPLOAD_MEDIA_SAVE_ADD: { 'x-api-id': 14, 'x-page-id': PAGE_IDS.VACANCY_UPLOAD_ADD } as const,
  VACANCY_UPLOAD_MEDIA_SAVE_EDIT: { 'x-api-id': 14, 'x-page-id': PAGE_IDS.VACANCY_UPLOAD_EDIT } as const,
  VACANCY_UPLOAD_APPROVE: { 'x-api-id': 20, 'x-page-id': PAGE_IDS.VACANCY_UPLOAD_EDIT } as const,

  VACANCY_INTERVIEW_QUESTIONS_LIST: { 'x-api-id': 40, 'x-page-id': PAGE_IDS.VACANCY_EDIT } as const,
  VACANCY_INTERVIEW_QUESTIONS_SAVE: { 'x-api-id': 41, 'x-page-id': PAGE_IDS.VACANCY_EDIT } as const,
  VACANCY_INTERVIEW_QUESTIONS_DELETE: { 'x-api-id': 42, 'x-page-id': PAGE_IDS.VACANCY_EDIT } as const,
  VACANCY_PREDEFINED_QUESTIONS: { 'x-api-id': 39, 'x-page-id': PAGE_IDS.VACANCY_EDIT } as const,

  VACANCY_ADD_CUSTOMER_SEARCH: { 'x-api-id': 17, 'x-page-id': PAGE_IDS.VACANCY_ADD } as const,
  VACANCY_EDIT_CUSTOMER_SEARCH: { 'x-api-id': 17, 'x-page-id': PAGE_IDS.VACANCY_EDIT } as const,

  VACANCY_SKILL_CREATE_SKILL: { 'x-api-id': 44, 'x-page-id': PAGE_IDS.VACANCY_ADD } as const,
  VACANCY_SKILL_TECHNOLOGIES_GET: { 'x-api-id': 9, 'x-page-id': PAGE_IDS.VACANCY_ADD } as const,
  VACANCY_SKILL_CREATE_TECHNOLOGY: { 'x-api-id': 45, 'x-page-id': PAGE_IDS.VACANCY_ADD } as const,

  VIEW_VACANCY_DETAIL_GET: { 'x-api-id': 11, 'x-page-id': PAGE_IDS.VIEW_VACANCY } as const,

  /** User profile + dropdowns (`docs/frontend.md`). Designations `x-api-id` may differ per DB seed — default `58`. */
  USER_PROFILE_GET: { 'x-api-id': 50, 'x-page-id': PAGE_IDS.USER_PROFILE } as const,
  USER_PROFILE_PUT: { 'x-api-id': 51, 'x-page-id': PAGE_IDS.USER_PROFILE } as const,
  USER_PROFILE_GENDERS: { 'x-api-id': 52, 'x-page-id': PAGE_IDS.USER_PROFILE } as const,
  USER_PROFILE_DEPARTMENTS: { 'x-api-id': 53, 'x-page-id': PAGE_IDS.USER_PROFILE } as const,
  USER_PROFILE_DESIGNATIONS: { 'x-api-id': 6, 'x-page-id': PAGE_IDS.USER_PROFILE } as const,
  USER_PROFILE_USER_ROLES: { 'x-api-id': 54, 'x-page-id': PAGE_IDS.USER_PROFILE } as const,
  USER_PROFILE_PERMISSION_LEVELS: { 'x-api-id': 55, 'x-page-id': PAGE_IDS.USER_PROFILE } as const,
  USER_PROFILE_EMPLOYMENT_TYPES: { 'x-api-id': 56, 'x-page-id': PAGE_IDS.USER_PROFILE } as const,
  USER_PROFILE_FUNCTIONAL_TEAMS: { 'x-api-id': 57, 'x-page-id': PAGE_IDS.USER_PROFILE } as const,

  SEND_MESSAGE_SEND: { 'x-api-id': 58, 'x-page-id': PAGE_IDS.SEND_MESSAGE } as const,
} as const;

/**
 * System designations lookup; `x-page-id` must match the active screen PermissionProvider context.
 */
export function createDesignationsLookupHeaders(pageId: number) {
  return { 'x-api-id': 6 as const, 'x-page-id': pageId };
}
